<template>
  <div v-for="(item, index) in multipleFormData" :key="index">
    <div class="d-flex justify-content-between align-items-center">
      <h3 class="mb-4">Form {{ index + 1 }}</h3>
      <div class="d-flex justify-content-between align-items-center gap-2">
        <button
          class="btn w-sm btn-primary waves-effect waves-light px-2"
          @click="copyNewForm(index)"
        >
          Copy
        </button>
        <button
          class="btn w-sm btn-success waves-effect waves-light px-2"
          @click="addnewForm()"
        >
          Add
        </button>
        <button
          @click="deleteForm(index)"
          v-if="index > 0"
          class="btn w-sm btn-danger waves-effect waves-light px-2"
        >
          Delete
        </button>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-lg-3">
        <label for="name">
          Name
          <span class="text-danger">*</span>
        </label>
      </div>

      <div class="col-lg-6">
        <input
          name="name"
          id="name"
          type="text"
          class="form-control"
          v-model="item.name"
          @input="(event) => handleChange('Name', index, event)"
        />
        <div class="text-danger" v-if="item.error?.name_error">
        {{ item.error?.name_error }}
      </div>
      </div>
      
    </div>

    <div class="row mb-3">
      <div class="col-lg-3">
        <label for="program">
          Program Name
          <span class="text-danger">*</span>
        </label>
      </div>

      <div class="col-lg-6">
        <div class="d-flex">
          <div class="d-flex align-items-center me-3">
            <input
              :checked="item.allCheck"
              @click="
                item.allCheck = true;
                item.program = [];
                item.type = '';
                item.level = '';
                item.assessment_criteria_percentage_id = '';
                item.assessment_criteria_percentage_id_error = '';
                filterAssessmentCriteriaList = [];
                item.type_error = '';
                item.level_error = '';
                item.error.program_error = '';
              "
              type="radio"
              :name="`choose-${index}`"
            />
            <label>All</label>
          </div>
          <div class="d-flex align-items-center">
            <input
              :checked="!item.allCheck"
              @click="
                item.allCheck = false;
                item.program = [];
                filterAssessmentCriteriaList = [];
                item.type = '';
                item.level = '';
                item.assessment_criteria_percentage_id = '';
                item.assessment_criteria_percentage_id_error = '';
                item.type_error = '';
                item.level_error = '';
                item.error.program_error = '';
              "
              type="radio"
              :name="`choose-${index}`"
            />
            <label>Select</label>
          </div>
        </div>

        <v-select
          :closeOnSelect="false"
          v-show="!item.allCheck"
          name="program"
          :clearable="false"
          id="program"
          :options="moduleList"
          label="name"
          :loading="!moduleList.length"
          multiple
          v-model="item.program"
          :selectable="(option) => selectedProgram(option, index)"
          @option:selected="handleChange('Program', index)"
          @option:deselected="handleChange('Program', index)"
          :class="{
            error: item.error?.program_error,
          }"
        />

        <div class="text-danger" v-if="item.error?.program_error">
          {{ item.error?.program_error }}
        </div>
      </div>
    </div>

    <div class="row mb-3">
                <div class="col-lg-3">
                  <label for="assessment_form">
                    Assessment Form
                    <span class="text-danger">*</span>
                  </label>
                </div>

                <div class="col-lg-6">
                  <v-select
                    :clearable="false"
                    name="assessment_form"
                    id="assessment_form"
                    :options="assessmentForms"
                    label="name"
                    class="border-danger"
                    v-model="item.assessment_form"
                    :selectable="
                      (val) => {
                        return val.id !== item.assessment_form?.id;
                      }
                    "
                  />

                  </div>
              </div>

    <div class="row mb-3">
      <div class="col-lg-3">
        <label for="type">
          Type
          <span class="text-danger">*</span>
        </label>
      </div>

      <div class="col-lg-6">
        <v-select
          name="type"
          id="type"
          :options="getType"
          label="name"
          v-model="item.type"
          :selectable="(option) => option?.name != item?.type?.name"
          class="border-danger"
          :clearable="false"
          @option:selected="handleChange('Type', index)"
          @option:deselected="handleChange('Type', index)"
        />
        <!-- :selectable="(val)=> selectableType(val)" -->

        <div class="text-danger" v-if="item.error?.type_error">
          {{ item.error?.type_error }}
        </div>
      </div>
    </div>

    <div class="row mb-3" v-if="item.type && item.type?.name != 'Orientation'">
      <div class="col-lg-3">
        <label for="remark">
          Level
          <span class="text-danger">*</span>
        </label>
      </div>

      <div class="col-lg-6">
        <v-select
          name="level"
          id="level"
          :options="getLevel"
          label="name"
          v-model="item.level"
          :selectable="(option) => option?.id != item?.level?.id"
          :clearable="false"
          @option:selected="handleChange('Level', index)"
          @option:deselected="handleChange('Level', index)"
        />

        <div class="text-danger" v-if="item.error?.level_error">
          {{ item.error?.level_error }}
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-lg-3">
        <label for="remark">
          Assessment Criteria Percentage
          <span class="text-danger">*</span>
        </label>
      </div>

      <div class="col-lg-6">
        <v-select
          :clearable="false"
          :options="filterAssessmentCriteriaList"
          label="code"
          :reduce="(val) => val.id"
          v-model="item.assessment_criteria_percentage_id"
          @option:selected="
            handleChange('Assessment Criteria Percentage', index)
          "
          @option:deselected="
            handleChange('Assessment Criteria Percentage', index)
          "
        >
          <template #selected-option="{code, percentage}">
            {{ code && code + ` (${percentage} %)` }}
          </template>
          <template v-slot:option="option">
            {{ option.code }} ({{ option.percentage }}%)
          </template>
        </v-select>

        <div
          class="text-danger"
          v-if="item.error?.assessment_criteria_percentage_id_error"
        >
          {{ item.error?.assessment_criteria_percentage_id_error }}
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-lg-3">
        <label for="remark">
          Point
          <span class="text-danger">*</span>
        </label>
      </div>

      <div class="col-lg-6">
        <input
          name="point"
          id="point"
          type="number"
          v-model="item.point"
          class="form-control"
          @input="(event) => handleChange('Point', index, event)"
        />
        <div class="text-danger" v-if="item.error?.point_error">
          {{ item.error?.point_error }}
        </div>
      </div>
    </div>
    <hr />
  </div>

  <div class="row">
    <div class="col-md-6 mx-auto">
      <div class="mt-3 mb-3 ms-3 text-center">
        <router-link :to="{ name: 'assessment-criteria' }">
          <button type="button" class="btn w-sm btn-secondary me-5">
            Cancel
          </button>
        </router-link>

        <button
          :disabled="isLoading ? true : false"
          type="button"
          class="btn w-sm btn-success waves-effect waves-light px-3"
          @click="store()"
        >
          <span
            v-if="isLoading"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>

          {{ isLoading == true ? "Loading..." : "Save" }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { useToast } from "vue-toastification";
import { levels } from "../../../const";
import { types } from "../../../const";

import validationErrors from "../../../mixins/validationErrors";

export default {
  props: {
    assessmentCriteriaPercentages: {
      type: Array,
      required: true,
    },
    assessmentForms: {
      type: Array,
      required: true,
    }
  },

  setup() {
    const toast = useToast();

    return { toast };
  },

  components: {
    vSelect,
  },

  mixins: [validationErrors],

  data() {
    return {
      multipleFormData: [
        {
          program: [],
          allCheck: false,
          name: "",
          level: "",
          type: "",
          point: "",
          assessment_form: "",
          assessment_criteria_percentage_id: "",
          error: {
            name_error: "",
            point_error: "",
            assessment_criteria_percentage_id_error: "",
            program_error: "",
            level_error: "",
            type_error: "",
          },
        },
      ],
      filterAssessmentCriteriaList: [],
      isLoading: false,
      allowStore: true,
      // formData : ,
      // allCheck : true,
      moduleList: this.$store.getters["odoo/getAllPrograms"],
      getLevel: levels,
      getType: types,
      isLoading: false,
      baseUrl: process.env.VUE_APP_BASE_URL,
    };
  },

  methods: {
    addnewForm() {
      this.multipleFormData.push({
        program: [],
        allCheck: false,
        name: "",
        level: "",
        type: "",
        point: "",
        assessment_form: "",
        assessment_criteria_percentage_id: "",
        error: {
          name_error: "",
          point_error: "",
          assessment_criteria_percentage_id_error: "",
          program_error: "",
          level_error: "",
          type_error: "",
        },
      });
    },

    copyNewForm(index) {
      const copiedObject = JSON.parse(JSON.stringify(this.multipleFormData[index]));
      this.multipleFormData.push(copiedObject);
    },

    deleteForm(index) {
      this.multipleFormData.splice(index, 1);
    },

    selectedProgram(options, index) {
      return !this.multipleFormData[index]?.program?.length
        ? true
        : this.multipleFormData[index].program.find(
            (p) => p.id == options.id
          ) === undefined;
    },

    handleChange(type, index, event) {
      if (type == "Name") {
        this.multipleFormData[index].name = event.target.value;
        if (!this.multipleFormData[index]?.name) {
          this.multipleFormData[index].error.name_error = "Name is required.";
        } else {
          this.multipleFormData[index].error.name_error = "";
        }
      } else if (type == "Program") {
        this.multipleFormData[index].type = "";
        this.multipleFormData[index].type_error = "";
        this.multipleFormData[index].level = "";
        this.multipleFormData[index].level_error = "";
        this.multipleFormData[index].assessment_criteria_percentage_id = "";
        this.multipleFormData[index].assessment_criteria_percentage_id_error =
          "";
        this.filterAssessmentCriteriaList = [];
        if (
          this.multipleFormData[index]?.program?.length === 0 &&
          !this.multipleFormData[index]?.allCheck
        ) {
          this.multipleFormData[index].error.program_error =
            "Program is required.";
        } else {
          this.multipleFormData[index].error.program_error = "";
        }
      } else if (type == "Type") {
        this.multipleFormData[index].level = "";
        this.multipleFormData[index].level_error = "";
        this.multipleFormData[index].assessment_criteria_percentage_id = "";
        this.multipleFormData[index].assessment_criteria_percentage_id_error =
          "";
        this.filterAssessmentCriteriaList = [];
        if (
          this.multipleFormData[index].type?.name === "Orientation" &&
          (this.multipleFormData[index].program.length > 0 ||
            this.multipleFormData[index].allCheck)
        ) {
          this.filterAssessmentCriteria(index);
        }
        if (!this.multipleFormData[index]?.type) {
          this.multipleFormData[index].error.type_error = "Type is required.";
        } else {
          this.multipleFormData[index].error.type_error = "";
        }
      } else if (type == "Assessment Criteria Percentage") {
        if (!this.multipleFormData[index]?.assessment_criteria_percentage_id) {
          this.multipleFormData[
            index
          ].error.assessment_criteria_percentage_id_error = "Type is required.";
        } else {
          this.multipleFormData[
            index
          ].error.assessment_criteria_percentage_id_error = "";
        }
      } else if (type == "Level") {
        this.multipleFormData[index].assessment_criteria_percentage_id = "";
        this.multipleFormData[index].assessment_criteria_percentage_id_error =
          "";
        this.filterAssessmentCriteriaList = [];
        if (
          this.multipleFormData[index].type &&
          (this.multipleFormData[index].program.length > 0 ||
            this.multipleFormData[index].allCheck) &&
          this.multipleFormData[index].level
        ) {
          this.filterAssessmentCriteria(index);
        }
        if (
          !this.multipleFormData[index]?.level &&
          this.multipleFormData[index]?.type?.name != "Orientation"
        ) {
          this.multipleFormData[index].error.level_error = "Level is required.";
        } else {
          this.multipleFormData[index].error.level_error = "";
        }
      } else if (type == "Point") {
        this.multipleFormData[index].point = Number(event?.target?.value);
        if (!this.multipleFormData[index]?.point) {
          this.multipleFormData[index].error.point_error = "Point is required.";
        } else {
          this.multipleFormData[index].error.point_error = "";
        }
      }
    },

    filterAssessmentCriteria(index) {
      if (this.multipleFormData[index].allCheck) {
        this.filterAssessmentCriteriaList = this.assessmentCriteriaPercentages.filter(
          (val) => {
            if (val.all_check) {
              if (this.multipleFormData[index].type?.name === "Orientation") {
                return val.type === "Orientation";
              } else {
                return (
                  val.level === this.multipleFormData[index].level?.name &&
                  val.type === this.multipleFormData[index].type?.name
                );
              }
            }
            return false;
          }
        );
      } else {
        this.filterAssessmentCriteriaList = this.assessmentCriteriaPercentages.filter(
          (val) => {
            const selectedIds = this.multipleFormData[index].program.map(
              (p) => p.id
            );
            const criteriaProgramIds = val.programs.map((p) => p.id);
            const typeMatches =
              val.type == this.multipleFormData[index].type?.name;
            const levelMatches =
              val.level == this.multipleFormData[index].level?.name;

            if (this.multipleFormData[index].type?.name === "Orientation") {
              return (
                typeMatches &&
                selectedIds.every((id) => criteriaProgramIds.includes(id))
              );
            } else {
              return (
                typeMatches &&
                levelMatches &&
                selectedIds.every((id) => criteriaProgramIds.includes(id))
              );
            }
          }
        );
      }
    },

    checkBeforeStore() {
      this.allowStore = true;
      this.multipleFormData.forEach((item) => {
        if (!item.name)
          (item.error.name_error = "Name is required."),
            (this.allowStore = false);
        if (item.program.length == 0 && !item.allCheck)
          (item.error.program_error = "Program is required."),
            (this.allowStore = false);
        if (!item.type)
          (item.error.type_error = "Type is required."),
            (this.allowStore = false);
        if (!item.level && item.type?.name != "Orientation")
          (item.error.level_error = "Level is required."),
            (this.allowStore = false);
        if (!item.assessment_criteria_percentage_id)
          (item.error.assessment_criteria_percentage_id_error =
            "Assessment Criteria is required."),
            (this.allowStore = false);
        if (!item.point)
          (item.error.point_error = "Point is required."),
            (this.allowStore = false);
      });
      console.log(this.multipleFormData, this.allowStore);
    },

    async store() {
      this.checkBeforeStore();
      if (this.allowStore) {

        const formData = [];

        this.multipleFormData.forEach((item) => {
          this.isLoading = true;

          let data = {
            name: item.name,
            program_ids: item.allCheck
              ? this.moduleList.map((val) => val.id)
              : item.program.map((val) => val.id),
            type: item.type.name,
            level: item.level ? item.level.name : null,
            all_check: item.allCheck ? 1 : 0,
            point: item.point ?? 0,
            assessment_form: item.assessment_form?.id ?? null,
            assessment_criteria_percentage_id: item.assessment_criteria_percentage_id ?? 0,
          };

          formData.push(data);
        });

        await axios
          .post(
            `${this.baseUrl}admin/v2/assessment-criteria-multiple`,
            formData
          )

          .then(() => {
            this.$router.push({ name: "assessment-criteria" });
            this.toast.success("Successfully Created Assessment Criteria!");
          })
          .catch((error) => {
            error.response.status == 502 ?
                            this.toast.error(error.response.data.errors.message) :
                            this.toast.error("Something Went Wrong!");
          });

        this.isLoading = false;
      } else {
        console.log("Not allowed to store,");
      }
    },
  },
};
</script>
